import React from 'react'

import { NextDialogProvider } from '../../../../app/_components/dialogs/NextDialog.client'
import { SizeChartModalService } from '../../../containers/SizeChartModalService'

import { SizeChartModalContent } from './SizeChartModalContent'
import { Dialog, DialogBody } from './styles'

export const SizeChartModal: React.FC = () => {
  const { closeSizeChartModal, shouldDisplaySizeChartModal, state } =
    SizeChartModalService.useContainer()

  if (state.modalState === 'Unopened') return null

  return (
    <NextDialogProvider open={shouldDisplaySizeChartModal}>
      <Dialog onClose={closeSizeChartModal}>
        <DialogBody>
          <SizeChartModalContent
            onClose={closeSizeChartModal}
            sizeChart={state.sizeChart}
            initialActiveTab={state.initialActiveTab}
          />
        </DialogBody>
      </Dialog>
    </NextDialogProvider>
  )
}
